import { memo, type ReactElement } from 'react';

import Box from '@mui/material/Box';
import { alpha, useTheme } from '@mui/material/styles';
import Tooltip from '@mui/material/Tooltip';

interface LineAutomationIconProps {
    title?: string | ReactElement;
    icon: ReactElement;
}

const LineAutomationIcon = memo(
    ({ title, icon }: LineAutomationIconProps): ReactElement => {
        const { palette } = useTheme();

        const iconElement = (
            <Box
                sx={{
                    height: 24,
                    width: 24,
                    display: 'grid',
                    border: `1px solid ${alpha(palette.primary.main, 0.2)}`,
                    boxSizing: 'border-box',
                    fill: palette.primary.main,
                    placeContent: 'center',
                }}
            >
                {icon}
            </Box>
        );

        if (!title) {
            return iconElement;
        }

        return (
            <Tooltip
                title={title}
                placement="top"
                leaveDelay={200}
            >
                {iconElement}
            </Tooltip>
        );
    }
);

LineAutomationIcon.displayName = 'LineAutomationIcon';

export { LineAutomationIcon };
